import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ overline, title, desc, id }) => (
  <div className="max-w-3xl" data-testid={id ? `${id}-heading` : undefined}>
    <Reveal>
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#3377FF]">{overline}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tighter leading-[1.02]">{title}</h2>
    </Reveal>
    {desc && (
      <Reveal delay={0.16}>
        <p className="mt-6 text-base md:text-lg text-[#A3A3A3] leading-relaxed">{desc}</p>
      </Reveal>
    )}
  </div>
);
